import React from 'react'
import CareerHero from '../Components/career/CareerHero'
import WhatWeOffer from '../Components/career/WhatWeOffer'
import PerksAndBenefits from '../Components/career/PerksAndBenefits'
import LatestOpenings from '../Components/career/LatestOpenings'
import { Helmet } from 'react-helmet-async'


function CareerDummy() {
  return (
    <div>
         <Helmet>
                <title>
                    Careers at Mobikode | Jobs & Technology Career Opportunities
                </title>

                <meta
                    name="description"
                    content="Explore career opportunities at Mobikode and join a technology-driven team working across AI, cloud engineering, product development, software engineering, Enterprise AI & ServiceNow Consulting, and enterprise technology."
                />

                <meta
                    name="keywords"
                    content="Mobikode Careers, Careers at Mobikode, Mobikode Jobs, Technology Jobs, IT Jobs, Software Developer Jobs, Software Engineering Careers, AI Jobs, Cloud Engineering Jobs, Product Engineering Jobs, IT Careers, Enterprise AI & ServiceNow Consulting Careers, Technology Career Opportunities, Software Development Careers, Engineering Jobs, Tech Careers"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/careers"
                />

                <meta
                    property="og:title"
                    content="Careers at Mobikode | Jobs & Technology Career Opportunities"
                />

                <meta
                    property="og:description"
                    content="Build your career with Mobikode. Discover opportunities to work with talented teams across AI, cloud, software engineering, product development, and Enterprise AI & ServiceNow Consulting."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/careers"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/career/bg1.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Careers at Mobikode | Jobs & Technology Career Opportunities"
                />

                <meta
                    name="twitter:description"
                    content="Find your next opportunity at Mobikode and grow with a technology team working on innovative software, AI, cloud, product engineering, and Enterprise AI & ServiceNow Consulting solutions."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/career/bg1.png"
                />
            </Helmet>
      <CareerHero />
      <WhatWeOffer />
      <PerksAndBenefits />
      <LatestOpenings />
    </div>
  )
}

export default CareerDummy
